<template>
    <div v-if="item">
        <v-row class="no-frame">
            <v-col class="no-frame">
                <div class="v-flex">
                    <inb-message-types
                        v-model   = "messageType"
                        label     = "Meldungsart"
                        :readonly = "readonly"
                        @changed  = "onMessagetype"
                    />
                    <div v-if="forceMorph" class="pt-4">
                        <c-toolbar-button
                            icon="mdi-thumb-up-outline"
                            size="22"
                            color="primary"
                            tooltip="Meldungsart bestätigen"
                            @click="onForceMorph"
                        />
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row class="no-frame">
            <v-col class="no-frame">
                <c-customer-select
                    v-model     = "item.customer"
                    :label      = "$t ('inb.detail.assessment.customer')"
                    :lim-customer = "true"
                    :additional = "item.customer"
                    :rules      = "[requiredRule]"
                    :readonly   = "readonly"
                    :clearable  = "!readonly"
                    @change     = "onCustomer"
                />
            </v-col>
        </v-row>
        <v-row class="no-frame" >
            <v-col class="no-frame">
                <v-alert
                    v-if  = "!item.customer && !loading"
                    color = "error"
                    type  = "error"
                    class = "pa-2 white--text mt-2"
                >
                    Der Meldung sind noch keine Anlagen zugeordnet. Zur Auswahl der Anlagen muss zuerst der Kunde angegeben werden.
                </v-alert>

                <c-site-select-multiple
                    v-if      = "item.customer"
                    :customer = "item.customer"
                    :sites    = "item.sites"
                    :readonly = "readonly"
                    :navigate = "false"
                    ref       = "sitelist"
                    @changed  = "onUnits"
                    :key      = "refresh"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Core                from "@/modules/core/service/Core";
import CCustomerSelect     from "@/modules/msd/company/customer/components/controlls/CCustomerSelect";
import CSiteSelectMultiple from "@/modules/msd/unit/components/controlls/CSiteSelectMultiple";
import InbMessageTypes     from "@/modules/inb/components/controlls/InbMessageTypes";
import CToolbarButton      from "@/modules/core/components/utils/CToolbarButton";

export default {
    name: "CInbContext",

    components: {
        CToolbarButton,
        InbMessageTypes,
        CSiteSelectMultiple,
        CCustomerSelect
    },

    props: {
        item: {

        },

        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        confirmMorph: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        forceMorph: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        }
    },

    data: () => ({
        messageType: null,
        loading    : false,
        refresh    : 0
    }),

    mounted() {
        this.loading = true;
        this.messageType = this.item.type;
    },

    computed: {
        requiredRule () {
            return Core.rule.required;
        },
    },

    watch: {
        item () {
            if (this.item) {
                this.messageType = this.item.type;
                this.loading = false;
            }
        }
    },

    methods: {
        closeMenu () {
            if (!this.$refs.sitelist) {
                return;
            }

            this.$refs.sitelist.onClose();
        },

        onCustomer () {
            this.item.type = this.messageType;
            this.$emit("changed", this.item);
            this.refresh ++;
        },

        onUnits () {
            this.item.type = this.messageType;
            this.$emit("changed", this.item)
        },

        onForceMorph () {
            this.$emit("morph", this.messageType)
        },

        onMessagetype (type) {
            if (this.confirmMorph) {
                Core.message.confirm(
                    this,
                    this.$t("inb.morph.query"),
                    this.$t("inb.morph.text", [ type.name ]),
                    Core.message.Default,
                    (value) => {
                        if (!value) {
                            return;
                        }

                        this.$emit("morph", type)
                    }
                );
            } else {
                this.$emit("morph", type)
            }
        },
    }
}
</script>

<style scoped>

</style>